var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar__content", attrs: { id: "sidebar__contentId" } },
    [
      _c("div", { staticClass: "sidebar__box sidebar__box--desktop" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.sortFilterIsActive },
            attrs: {
              type: "button",
              "data-sort-filter": "",
              "data-gtm": "sidebar__sort--filter",
              "data-pendo": "sidebar__sort--filter",
              "aria-label": "Sort filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("sort")
                _vm.scrollFilterContent(
                  "sortFilter",
                  "[data-sort-filter]",
                  _vm.sortFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.trans("SORT")) + "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _c("span", { staticClass: "sidebar__filterSetting" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.sortValue) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.sortFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sortFilterIsActive,
                expression: "sortFilterIsActive",
              },
            ],
            ref: "sortFilter",
            class: { sidebar__filterActive: _vm.sortFilterIsActive },
          },
          [
            _c("SortFilter", {
              on: { "selected-sort-config": _vm.emittedSortSelection },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.contentTypeFilterIsActive },
            attrs: {
              type: "button",
              "data-content-filter": "",
              "data-gtm": "sidebar__contentType--filter",
              "data-pendo": "sidebar__contentType--filter",
              "aria-label": "Content type filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("contentType")
                _vm.scrollFilterContent(
                  "contentFilter",
                  "[data-content-filter]",
                  _vm.contentTypeFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("CONTENT_TYPES")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _vm.contentTypeValue.length > 0
                ? _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.contentTypeValue.length) +
                        "\n                    "
                    ),
                    _vm.contentTypeValue.length > 1
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.trans("FILTER_SETTINGS_MULTIPLE"))),
                        ])
                      : _c("span", [
                          _vm._v(" " + _vm._s(_vm.trans("FILTER_SETTINGS"))),
                        ]),
                  ])
                : _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("STATISTIC_OPTIONS_DATAPOINTS_ALL")) +
                        "\n                "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.contentTypeFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentTypeFilterIsActive,
                expression: "contentTypeFilterIsActive",
              },
            ],
            ref: "contentFilter",
            class: { sidebar__filterActive: _vm.contentTypeFilterIsActive },
          },
          [
            _c("ContentTypeFilter", {
              on: { "selected-contentTypes": _vm.emittedContentTypeValue },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.accuracyFilterIsActive },
            attrs: {
              type: "button",
              "data-accuracy-filter": "",
              "data-gtm": "sidebar__accuracy--filter",
              "data-pendo": "sidebar__accuracy--filter",
              "aria-label": "Accuracy filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("accuracy")
                _vm.scrollFilterContent(
                  "accuracyFilter",
                  "[data-accuracy-filter]",
                  _vm.accuracyFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("ACCURACY")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _c("span", { staticClass: "sidebar__filterSetting" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.accuracyValue) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.accuracyFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.accuracyFilterIsActive,
                expression: "accuracyFilterIsActive",
              },
            ],
            ref: "accuracyFilter",
            class: { sidebar__filterActive: _vm.accuracyFilterIsActive },
          },
          [
            _c("AccuracyFilter", {
              on: { "selected-accuracy-text": _vm.emittedAccuracyValue },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.locationFilterIsActive },
            attrs: {
              type: "button",
              "data-location-filter": "",
              "data-gtm": "sidebar__location--filter",
              "data-pendo": "sidebar__location--filter",
              "aria-label": "Location filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("location")
                _vm.scrollFilterContent(
                  "locationFilter",
                  "[data-location-filter]",
                  _vm.locationFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("GLOBAL_LOCATION")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _vm.countriesValue.length === 0
                ? _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.regionValue.label) +
                        "\n                "
                    ),
                  ])
                : _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.countriesValue.length) +
                        "\n                    "
                    ),
                    _vm.countriesValue.length > 1
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.trans("FILTER_SETTINGS_MULTIPLE"))),
                        ])
                      : _c("span", [
                          _vm._v(" " + _vm._s(_vm.trans("FILTER_SETTINGS"))),
                        ]),
                  ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.locationFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.locationFilterIsActive,
                expression: "locationFilterIsActive",
              },
            ],
            ref: "locationFilter",
            class: { sidebar__filterActive: _vm.locationFilterIsActive },
          },
          [
            _c("LocationFilter", {
              on: {
                "selected-region": _vm.emittedRegionValue,
                "selected-countries": _vm.emittedCountriesValue,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box sidebar__box--desktop" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: {
              "sidebar__filter--active": _vm.regionalBoostFilterIsActive,
            },
            attrs: {
              type: "button",
              "data-regionalBoost-filter": "",
              "data-gtm": "sidebar__regionalBoost--filter",
              "data-pendo": "sidebar__regionalBoost--filter",
              "aria-label": "Regional boost Filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("regionalBoost")
                _vm.scrollFilterContent(
                  "regionalBoostFilter",
                  "[data-regionalBoost-filter]",
                  _vm.regionalBoostFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_SEARCH_REGION_FOCUS_MOBILE")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _c("span", { staticClass: "sidebar__filterSetting" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.regionalBoostName) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.regionalBoostFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.regionalBoostFilterIsActive,
                expression: "regionalBoostFilterIsActive",
              },
            ],
            ref: "regionalBoostFilter",
            class: { sidebar__filterActive: _vm.regionalBoostFilterIsActive },
          },
          [
            _c("RegionalBoostFilter", {
              attrs: { "sort-selection": _vm.sortSelection },
              on: { "selected-regionalBoost": _vm.emittedRegionalBoostValue },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.industryFilterIsActive },
            attrs: {
              type: "button",
              "data-industry-filter": "",
              "data-gtm": "sidebar__industry--filter",
              "data-pendo": "sidebar__industry--filter",
              "aria-label": "Industry Filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("industry")
                _vm.scrollFilterContent(
                  "industryFilter",
                  "[data-industry-filter]",
                  _vm.industryFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_INDUSTRY")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _c("span", [
                _vm.subCategoryValue.length > 0 &&
                !_vm.subCategoryValue.includes(_vm.ALL_OPTIONS_SELECTED)
                  ? _c("span", { staticClass: "sidebar__filterSetting" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.subCategoryValue.length) +
                          "\n                        "
                      ),
                      _c("span", [
                        _vm._v(_vm._s(_vm.trans("FILTER_SETTINGS_MULTIPLE"))),
                      ]),
                    ])
                  : _c("span", { staticClass: "sidebar__filterSetting" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.trans("STATISTIC_OPTIONS_DATAPOINTS_ALL")
                          ) +
                          "\n                    "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.industryFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.industryFilterIsActive,
                expression: "industryFilterIsActive",
              },
            ],
            ref: "industryFilter",
            class: { sidebar__filterActive: _vm.industryFilterIsActive },
          },
          [
            _c("IndustryFilter", {
              attrs: {
                "selected-categories-value": _vm.selectedCategoriesValue,
              },
              on: {
                "selected-category": _vm.emittedCategoryValue,
                "selected-sub-category": _vm.emittedSubCategoryValue,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: {
              "sidebar__filter--active": _vm.publicationDateFilterIsActive,
            },
            attrs: {
              type: "button",
              "data-publication-filter": "",
              "data-gtm": "sidebar__publicationDate--filter",
              "data-pendo": "sidebar__publicationDAte--filter",
              "aria-label": "Publication date filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("publicationDate")
                _vm.scrollFilterContent(
                  "publicationFilter",
                  "[data-publication-filter]",
                  _vm.publicationDateFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_FILTER_PUBLICATION_DATE")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _vm.intervalValue[0] === _vm.ALL_OPTIONS_SELECTED ||
              _vm.intervalValue.length === 0
                ? _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("STATISTIC_OPTIONS_DATAPOINTS_ALL")) +
                        "\n                "
                    ),
                  ])
                : _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.intervalValue.length) +
                        "\n                    "
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm.trans("FILTER_SETTINGS_MULTIPLE"))),
                    ]),
                  ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.publicationDateFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.publicationDateFilterIsActive,
                expression: "publicationDateFilterIsActive",
              },
            ],
            ref: "publicationFilter",
            class: { sidebar__filterActive: _vm.publicationDateFilterIsActive },
          },
          [
            _c("PublicationDateFilter", {
              on: { "selected-interval": _vm.emittedIntervalValue },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__box" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__filter sidebar__filter--text",
            class: { "sidebar__filter--active": _vm.archiveFilterIsActive },
            attrs: {
              type: "button",
              "data-archive-filter": "",
              "data-gtm": "sidebarFilter__archive--filter",
              "data-pendo": "sidebarFilter__archive--filter",
              "aria-label": "Archive filter",
            },
            on: {
              click: function ($event) {
                _vm.toggleFilter("archive")
                _vm.scrollFilterContent(
                  "archiveFilter",
                  "[data-archive-filter]",
                  _vm.archiveFilterIsActive
                )
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_SEARCH_ARCHIVE_LABEL")) +
                "\n            "
            ),
            _c("span", { staticClass: "sidebar__filterItem" }, [
              _c("span", { staticClass: "sidebar__filterSetting" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.archiveValue) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: {
                    sidebar__icon: true,
                    "sidebar__icon--open": _vm.archiveFilterIsActive,
                  },
                  attrs: {
                    height: "16px",
                    width: "16px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.archiveFilterIsActive,
                expression: "archiveFilterIsActive",
              },
            ],
            ref: "archiveFilter",
            class: { sidebar__filterActive: _vm.archiveFilterIsActive },
          },
          [
            _c("ArchiveFilter", {
              on: { "selected-archive-name": _vm.emittedArchiveValue },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.currentLanguage !== "en"
        ? _c("div", { staticClass: "sidebar__box" }, [
            _c(
              "button",
              {
                staticClass: "sidebar__filter sidebar__filter--text",
                class: {
                  "sidebar__filter--active": _vm.languageFilterIsActive,
                },
                attrs: {
                  type: "button",
                  "data-language-filter": "",
                  "data-gtm": "sidebarFilter__language--filter",
                  "data-pendo": "sidebarFilter__language--filter",
                  "aria-label": "Language filter",
                },
                on: {
                  click: function ($event) {
                    _vm.toggleFilter("language")
                    _vm.scrollFilterContent(
                      "languageFilter",
                      "[data-language-filter]",
                      _vm.languageFilterIsActive
                    )
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("FORM_SEARCH_LANGUAGE_LABEL")) +
                    "\n            "
                ),
                _c("span", { staticClass: "sidebar__filterItem" }, [
                  _c("span", { staticClass: "sidebar__filterSetting" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.languageValue) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      class: {
                        sidebar__icon: true,
                        "sidebar__icon--open": _vm.languageFilterIsActive,
                      },
                      attrs: {
                        height: "16px",
                        width: "16px",
                        "aria-hidden": "true",
                      },
                    },
                    [_c("use", { attrs: { href: "#iconChevronDownBold" } })]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.languageFilterIsActive,
                    expression: "languageFilterIsActive",
                  },
                ],
                ref: "languageFilter",
                class: { sidebar__filterActive: _vm.languageFilterIsActive },
              },
              [
                _c("LanguageFilter", {
                  on: { "selected-language-name": _vm.emittedLanguageValue },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }